import { combineReducers } from "redux";
import { TaskResult } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_TASK_RESULTS_REQUEST } from "./constants";
import { Action } from "./types";

function items(state: TaskResult[] = [], action: Action): TaskResult[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_TASK_RESULTS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_TASK_RESULTS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_TASK_RESULTS_REQUEST):
    case getFailureActionType(FETCH_TASK_RESULTS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const taskResults = combineReducers({ items, isFetching });
